import { handleAPI, API_VERSION_TWO } from 'utils/apiUtils'
import { Action } from 'types/redux'
import * as actions from './actions'

export function vacationSettlementCalculationLoad(): Action {
  const url = `/${API_VERSION_TWO}/onboarding/payroll/payrun_configurations/is_attendance_review_required_for_vacation_settlement`
  return {
    type: actions.ONBOARDING_VACATION_SETTLEMENT_CALCULATION_LOAD,
    payload: handleAPI(url, {}, 'GET'),
  }
}

export function vacationSettlementCalculationUpdate(data: { value: boolean }): Action {
  const url = `/${API_VERSION_TWO}/onboarding/payroll/payrun_configurations/is_attendance_review_required_for_vacation_settlement`
  return {
    type: actions.ONBOARDING_VACATION_SETTLEMENT_CALCULATION_UPDATE,
    payload: handleAPI(url, {}, 'PUT', { payrun_configuration: data }),
  }
}
